export default "__VITE_ASSET__CLD71FBh__"